import { AttachmentsValueValidator } from "./ValueValidators/AttachmentsValueValidator";
import { CompositeValueValidatorWithForcedValidators } from "./ValueValidators/CompositeValueValidatorWithForcedValidators";
import { CustomValueValidator } from "./ValueValidators/CustomValueValidator";
import { DigestConditionValueValidator } from "./ValueValidators/DigestConditionValueValidator";

export const Validators = {
    CompositeValueValidatorWithForcedValidators: CompositeValueValidatorWithForcedValidators,
    CustomValueValidator: CustomValueValidator,
    DigestConditionValueValidator: DigestConditionValueValidator,
    AttachmentsValueValidator: AttachmentsValueValidator,
};
